import React, { useEffect, useState } from 'react'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import Room from '@material-ui/icons/Room'
import Typography from '@material-ui/core/Typography'
import useTheme from '@material-ui/core/styles/useTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'
import TextField from '@material-ui/core/TextField'
import { useRest } from '../../contexts/rest/use'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { DropdownMenu } from '../helpers/dropdownmenu'
import { useConfig } from '../../contexts/config/use'

export const LandingPageTop = ({organization, searchboxlabel, searchbuttontext, findnearmetext, ortext, noresulttext }) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const [searchparams, setSearchParams] = useState();
  const [menuitems, setMenuItems] = useState();
  const { state: {config}} = useConfig();
  const { state: { offices }, actions: { handleGeolocationUpdate, updateSearchFilter } } = useRest();

  useEffect(() => {
    if (config)
    {
      setMenuItems(<DropdownMenu languages={config ? config.languages : null}/>);
    }
    else
      setMenuItems(<span/>);
  }, [config])

  const FindClosestOffice = () => {
    handleGeolocationUpdate();
  }

  const submitHandler = (event) => {
    if (event)
    {
      event.preventDefault();
      const result = offices.some(x => x.name === searchparams || Object.values(x.address).some(y => y === searchparams));
      if (result || searchparams === "")
        updateSearchFilter(searchparams);
    }
  }

  const searchParamsHandler = (event, autofill) => {
    if (autofill)
      setSearchParams(event.target.textContent);
    else
      setSearchParams(event.target.value);
  }

  useEffect(() => {
    if (searchparams === "")
      submitHandler();
  }, [searchparams])

  return (
    <section className={classes.container}>
      <div className={classes.innercontainer}>
        <div className={classes.menuwrapper}>
          <div className={classes.menutextwrapper}>
            <Typography variant="h4" className={[classes.heading, "titles"].join(' ')} id="landing-organization-title">
              {organization || ""}
            </Typography>
          </div>
          <div className={classes.menubuttonwrapper}>
            { menuitems }
          </div>
        </div>
        <form className={classes.form} onSubmit={(e) => submitHandler(e)}>
          <Autocomplete 
            className={classes.searchbox}
            id="searchfieldparams"
            onChange={(e) => searchParamsHandler(e, true)}
            freeSolo={true}
            noresulttext={noresulttext || "Inga träffar"}
            options={offices ? offices.map(x => x.name) : []}
            renderInput={(params) => (
              <TextField  
              {...params}
              id="locationtext"
              autoComplete="off"
              label={searchboxlabel || "Sök via namn eller ort"}
              variant="outlined"
              size="small"
              onChange={searchParamsHandler}
              onKeyDown={e => { if (e.key === "Enter" && e.target.value) 
              {
                submitHandler(e);
              }}}
              />
            )}
          />
          <div className={classes.buttonwrapper}>
            <Button type="submit" className={[classes.button, "buttons", "landing-buttons", "primary-buttons"].join(' ')} id="landing-button-search-id" >
              <Typography variant="button" classes={["buttons-text", "landing-buttons-text"].join(' ')}>
                {searchbuttontext || "Sök"}
              </Typography>
            </Button>
            <Typography variant="h6" className={classes.betweenbuttons} id="landing-betweenbuttons-id">
              { ortext || "ELLER" }
            </Typography>
            <Button className={[classes.button, "buttons", "landing-buttons", "primary-buttons"].join(' ')} onClick={FindClosestOffice} id="landing-button-nearme-id">
              <IconButton className={classes.iconbutton}  aria-label="sök-knapp">
                <Room className={[classes.icon, "icons"].join(' ')} id="landing-button-nearme-icon-id"/>
              </IconButton>
              <Typography variant="button" classes={["buttons-text", "landing-buttons-text"].join(' ')}>
                { findnearmetext || "Nära mig"}
              </Typography>
            </Button>
          </div>
        </form>
      </div>
    </section>
  )
}

const useStyles = makeStyles({
  container: theme => ({
    backgroundColor: theme.palette.background.main,
    marginLeft: '1rem',
    marginRight: '1rem',
    textAlign: 'left',
    flex: '0 1 auto',
    marginTop: '1rem',
    justifyContent: 'center'
  }),
  innercontainer: {
    padding: '0 1rem',
    marginBottom: '1.5rem'
  },
  menuwrapper: {
    display: 'flex', 
    width: '100%'
  },
  menutextwrapper: {
    display: 'flex', 
    width: '90%', 
    flex: '0 1 auto'
  },
  menubuttonwrapper: {
    display: 'flex', 
    flex: '1 0 auto',
    justifyContent: 'flex-end'

  },
  button: theme => ({
    fontSize: '2 rem',
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.button_text.main,
    justifyContent: 'center',
    alignItems: 'center',
    border: 'none',
    minWidth: '40%',
    [theme.breakpoints.up('lg')]: {
      '&:hover': {
        backgroundColor: 'black',
        color: 'white'
      }
    },
    [theme.breakpoints.down('lg')]: {
      '&:hover': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.button_text.main
      }
    }
    }),
    icon: theme => ({
      color: theme.palette.button_text.main
    }),
    iconbutton: {
      padding: 0
    },
    heading: {
      fontWeight: '500',
      color: 'black',
      padding: '0.2rem 0'
    },
    searchboxwrapper: {
      display: 'flex',
      flexDirection: 'row',
      position: 'relative'
    },
    searchbox: {
      marginTop: '0.5rem'
    },
    label: {
      fontSize: '1rem',
      paddingBottom: '0.2rem'
    },
    form: {
      display: 'flex',
      flexDirection: 'column'
    },
    betweenbuttons: theme => ({
      fontWeight: '500',
      padding: '0 0.5rem',
      color: theme.palette.secondary_text.main
    }),
    buttonwrapper: {
      display: 'flex',
      flexDirection: 'row',
      padding: '1rem 0',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    searchicon: theme => ({
      position: 'absolute',
      top: '0.2rem',
      left: '0.2rem',
      width: '1rem',
      color: theme.palette.secondary_text.main,
      height: '1.2rem'
    })
  })
